import { useTranslation } from '@thoughtspot/i18n';
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState, } from 'react';
import { Key } from 'w3c-keys';
import { Popover } from '../popover';
import { SwatchShapeOptions } from '../selectors';
import { Color } from '../selectors/color/color';
import { Font } from '../selectors/font-selector/font';
import { ColorPickerMenu } from './colorpicker-menu';
export var SELECTOR_TYPE;
(function (SELECTOR_TYPE) {
    SELECTOR_TYPE["FONT"] = "FONT";
    SELECTOR_TYPE["COLOR"] = "COLOR";
})(SELECTOR_TYPE || (SELECTOR_TYPE = {}));
export const ColorPicker = ({ headerSelectorType = SELECTOR_TYPE.COLOR, headerTitle, defaultValue = '', viewType, onChange, swatchShape = SwatchShapeOptions.DEFAULT, isReferenceVisible = false, isGradientEnabled = false, tabIndex = 0, border = undefined, disabled = false, ...restProps }) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const [target, setTarget] = useState();
    const [currentSelectedOption, setCurrentSelectedOption] = useState(defaultValue);
    const menuRef = useRef(null);
    const wrapperRef = useRef(null);
    const [popoverAlign, setPopoverAlign] = useState('bottom-start');
    useEffect(() => {
        setCurrentSelectedOption(defaultValue);
    }, [defaultValue]);
    const onChangeHandler = (selectedColor) => {
        // default color string's case gets toggled within the color picker
        if (currentSelectedOption.toUpperCase() !== selectedColor.toUpperCase()) {
            setCurrentSelectedOption(selectedColor);
            onChange(selectedColor);
        }
    };
    const onHeaderChangeHandler = (event, isVisible) => {
        setTarget(event);
        setVisible(isVisible);
    };
    const handleDocumentEvent = useCallback((event) => {
        if ((menuRef.current && menuRef.current.contains(event.target)) ||
            (target &&
                target.current &&
                target.current.contains(event.target))) {
            // click handler inside select menu options
            return;
        }
        setVisible(false);
    }, [target]);
    const handleEscape = useCallback((event) => {
        var _a;
        if (event.key !== Key.Escape || !visible)
            return;
        (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setVisible(false);
    }, [visible]);
    useEffect(() => {
        document.addEventListener('mousedown', handleDocumentEvent, {
            capture: false,
        });
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleDocumentEvent, {
                capture: false,
            });
            document.removeEventListener('keydown', handleEscape);
        };
    }, [handleDocumentEvent, handleEscape, menuRef]);
    useEffect(() => {
        var _a;
        if (visible) {
            (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [visible]);
    const checkPopoverPosition = useCallback(() => {
        if (menuRef.current) {
            const rect = menuRef.current.getBoundingClientRect();
            const isOutOfViewport = rect.bottom >= window.innerHeight;
            setPopoverAlign(isOutOfViewport ? 'top-start' : 'bottom-start');
        }
    }, [menuRef]);
    useLayoutEffect(() => {
        if (visible) {
            checkPopoverPosition();
        }
    }, [visible, checkPopoverPosition]);
    return (React.createElement("div", null,
        headerSelectorType === SELECTOR_TYPE.COLOR ? (React.createElement(Color, { title: headerTitle, selectedOption: currentSelectedOption, onChange: onHeaderChangeHandler, isToggle: visible, swatchShape: swatchShape, showBorder: true, border: border, isGradientEnabled: isGradientEnabled, baseDivRef: wrapperRef, tabIndex: tabIndex, ariaLabel: t('Color') })) : (React.createElement(Font, { title: headerTitle, selectedOption: currentSelectedOption, onChange: onHeaderChangeHandler, isToggle: visible, baseDivRef: wrapperRef, ariaLabel: t('fontPreview.fontProperties.COLOR') })),
        React.createElement(Popover, { content: React.createElement(ColorPickerMenu, { viewType: viewType, defaultValue: currentSelectedOption, onChange: onChangeHandler, isVisible: visible, setIsVisible: (isVisible) => setVisible(isVisible), targetRef: target, menuRef: menuRef, disabled: disabled, ...restProps }), targetRef: target, popperRef: menuRef, align: popoverAlign, appendToBody: true, isVisible: visible, isReferenceVisible: isReferenceVisible, autoFocusOnVisible: true })));
};
//# sourceMappingURL=colorpicker.js.map